import React, { Fragment, useState, useEffect, useRef } from 'react';
import { Btn, Spinner } from '../../../../../AbstractElements';
import { Card, CardBody, Col, Table, Form, FormGroup, Label, Row, CardHeader } from 'reactstrap';
import axios from 'axios';
import config from '../../../../../config';
import { toast } from 'react-toastify';
import ReactPaginate from 'react-paginate';
import * as XLSX from 'xlsx';
import jsPDF from 'jspdf';
import 'jspdf-autotable';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faFileExcel, faFilePdf } from '@fortawesome/free-solid-svg-icons';
import { faSort, faSortUp, faSortDown } from '@fortawesome/free-solid-svg-icons';

const dropdownItemStyle = {
    padding: '10px 14px',
    cursor: 'pointer',
    fontSize: '14px',
    backgroundColor: '#fff'
};

const SUMMARY_COLUMNS = [
    { label: 'Tenant', key: 'tenant_name' },
    { label: 'Tcode', key: 'tenant_code' },
    { label: 'Location', key: 'property_name' },
    { label: 'Category', key: 'category_name' },
    { label: 'Gross', key: 'gross_sales', format: 'number' },
    { label: 'Tax', key: 'tax', format: 'number' },
    { label: 'Net', key: 'net_sales', format: 'number' },
    { label: 'Txn', key: 'txn' },
    { label: 'ATV', key: 'atv', format: 'number' },
    { label: 'MoM %', key: 'growth_mom', format: 'percent' },
    { label: 'YoY %', key: 'growth_yoy', format: 'percent' }
];

const CATEGORY_INDEX = SUMMARY_COLUMNS.findIndex(
    c => c.key === 'category_name'
);

const MonthlySalesTrendReportView = () => {

    if (localStorage.getItem("accessReports") !== "1") {
        alert('You are not authorized to view this page');
        window.history.back(); // Navigate back to the previous URL
    }

    const concessionaire_id = localStorage.getItem("concessionaireId");
    const property_access = localStorage.getItem("propertyAccess");
    const [propertyAccessNames, setPropertyAccesssNames] = useState('');
    const login_name = localStorage.getItem("loginName");
    const login_id = localStorage.getItem("loginId");
    const [properties, setProperties] = useState([]);
    const [categories, setCategories] = useState([]);
    const [group_name, setGroupName] = useState('');
    const [groups, setGroups] = useState([]);
    const [allSubcategories, setAllSubcategories] = useState([]);
    const [subcategories, setSubcategories] = useState([]);
    const [allTenants, setAllTenants] = useState([]);
    const [tenants, setTenants] = useState([]);
    const [property_id, setPropertyId] = useState('');
    const [category_id, setCategoryId] = useState('');
    const [subcategory_id, setSubcategoryId] = useState('');
    const [tenant_id, setTenantId] = useState('');
    const [ReportData, setReportData] = useState([]);
    const [currentPage, setCurrentPage] = useState(0);
    const [itemsPerPage] = useState(50);
    const [validationMessage, setValidationMessage] = useState('');
    const [loading, setLoading] = useState(false)
    const today = new Date().toISOString().split('T')[0];
    const currentMonth = today.slice(0, 7);
    const [sortConfig, setSortConfig] = useState({ key: '', direction: 'asc' });
    const [tooltip, setTooltip] = useState('');
    const handleMouseEnter = (text) => setTooltip(text);
    const handleMouseLeave = () => setTooltip('');

    const [selectedTenants, setSelectedTenants] = useState([]);
    const [dropdownOpen, setDropdownOpen] = useState(false);

    const dropdownRef = useRef(null);
    const [searchTenant, setSearchTenant] = useState('');
    const getYesterdayMonth = () => {
        const d = new Date();
        d.setDate(d.getDate() - 1);
        return `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, '0')}`;
    };
    const [startMonth, setStartMonth] = useState(getYesterdayMonth());
    const [endMonth, setEndMonth] = useState(getYesterdayMonth());

    const [expandedTenants, setExpandedTenants] = useState({});
    const [monthlyDataMap, setMonthlyDataMap] = useState({}); // cache monthly data per tenant
    const [monthlyLoading, setMonthlyLoading] = useState({})
    const isAnyExpanded = Object.values(expandedTenants).some(Boolean);
    const [exportMenuOpen, setExportMenuOpen] = useState(false);
    const exportRef = useRef(null);
    const toggleDropdown = () => { setDropdownOpen(!dropdownOpen); };
    const [pdfMenuOpen, setPdfMenuOpen] = useState(false);
    const pdfRef = useRef(null);

    const token = localStorage.getItem("sessiontoken");
    const configheader = {
        headers: {
            Authorization: `${token}`
        }
    };

    const getFirstDayOfMonth = (ym) => {
        const [year, month] = ym.split("-");
        return `${year}-${month}-01`;
    };

    const getLastDayOfMonth = (ym) => {
        const [year, month] = ym.split("-");
        const lastDay = new Date(year, month, 0).getDate();
        return `${year}-${month}-${String(lastDay).padStart(2, "0")}`;
    };

    const formatMonthKey = (monthKey) => {
        if (!monthKey) return '';

        const [year, month] = monthKey.split('-');
        const date = new Date(year, Number(month) - 1, 1);
        return `${date.toLocaleString('en-US', { month: 'short' })}-${year}`;
    };

    // Close dropdown when clicking outside
    useEffect(() => {
        const handleClickOutside = (event) => {
            if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
                setDropdownOpen(false);
            }

            if (exportRef.current && !exportRef.current.contains(event.target)) {
                setExportMenuOpen(false);
            }

            if (pdfRef.current && !pdfRef.current.contains(event.target)) {
                setPdfMenuOpen(false);
            }
        };

        document.addEventListener('click', handleClickOutside, true);
        return () => document.removeEventListener('click', handleClickOutside, true);
    }, []);


    const handleExportHoverIn = (e) => {
        e.currentTarget.style.backgroundColor = '#00b1c2';
        e.currentTarget.style.color = '#ffffff';
    };

    const handleExportHoverOut = (e) => {
        e.currentTarget.style.backgroundColor = '#fff';
        e.currentTarget.style.color = '#000000';
    };

    useEffect(() => {
        axios
            .post(`${config.hostname}/property/getpropertybyconcessionaire`, { property_concessionaire_id: concessionaire_id, property_id: property_access }, configheader)
            .then((response) => {
                setProperties(response.data);
                const propertyNames = response.data.map(property => property.property_name).join(',');
                setPropertyAccesssNames(propertyNames);
            })
            .catch((error) => {
                console.log(error);
            });
    }, []);

    useEffect(() => {
        axios
            .post(`${config.hostname}/tenant/getgroupnames`, { tenant_concessionaire_id: concessionaire_id, property_id: property_access }, configheader)
            .then((response) => {
                setGroups(response.data)
            })
            .catch((error) => {
                console.log(error);
            });
    }, []);

    useEffect(() => {
        axios
            .post(`${config.hostname}/category/getcategorybyconcessionaire`, { category_concessionaire_id: concessionaire_id }, configheader)
            .then((response) => {
                setCategories(response.data);
            })
            .catch((error) => {
                console.log(error);
            });
    }, []);


    useEffect(() => {
        axios
            .post(`${config.hostname}/subcategory/getsubcategorybyconcessionaire`, { subcategory_concessionaire_id: concessionaire_id }, configheader)
            .then((response) => {
                setAllSubcategories(response.data);
                setSubcategories(response.data); // Initial set to all subcategories
            })
            .catch((error) => {
                console.log(error);
            });
    }, []);


    useEffect(() => {
        let filteredSubcategories = allSubcategories;

        if (category_id !== '') {
            filteredSubcategories = filteredSubcategories.filter(subcategory => subcategory.category_id._id === category_id);
        }

        setSubcategories(filteredSubcategories);
    }, [category_id]);

    useEffect(() => {
        axios
            .post(`${config.hostname}/tenant/getenantsbyconcessionaire`, { tenant_concessionaire_id: concessionaire_id, property_id: property_access }, configheader)
            .then((response) => {
                setAllTenants(response.data);
                setTenants(response.data);
            })
            .catch((error) => {
                console.log(error);
            });
    }, []);

    useEffect(() => {
        let filteredTenants = allTenants;

        if (group_name !== '') {
            filteredTenants = filteredTenants.filter(tenant => tenant.tenant_group_name === group_name);
        }

        if (category_id !== '') {
            filteredTenants = filteredTenants.filter(tenant => tenant.tenant_category_id._id === category_id);
        }

        if (property_id !== '') {
            filteredTenants = filteredTenants.filter(tenant => tenant.tenant_property_id._id === property_id);
        }

        if (subcategory_id !== '') {
            filteredTenants = filteredTenants.filter(tenant => tenant.tenant_subcategory_id._id === subcategory_id);
        }

        setTenants(filteredTenants);
    }, [group_name, property_id, category_id, subcategory_id, allTenants]);

    const sortedSummaryData = React.useMemo(() => {
        let data = [...ReportData];

        if (!sortConfig.key) return data;

        return data.sort((a, b) => {
            const aVal = a[sortConfig.key];
            const bVal = b[sortConfig.key];

            if (typeof aVal === 'number' && typeof bVal === 'number') {
                return sortConfig.direction === 'asc' ? aVal - bVal : bVal - aVal;
            }

            return sortConfig.direction === 'asc'
                ? String(aVal ?? '').localeCompare(String(bVal ?? ''))
                : String(bVal ?? '').localeCompare(String(aVal ?? ''));
        });
    }, [ReportData, sortConfig]);


    const flattenedRows = React.useMemo(() => {
        const rows = [];

        sortedSummaryData.forEach(summary => {
            // SUMMARY ROW
            rows.push({
                type: 'summary',
                tenant_id: summary.tenant_id,
                data: summary
            });

            // MONTHLY ROWS (if expanded)
            if (expandedTenants[summary.tenant_id]) {
                (monthlyDataMap[summary.tenant_id] || []).forEach(m => {
                    rows.push({
                        type: 'monthly',
                        tenant_id: summary.tenant_id,
                        data: m
                    });
                });
            }
        });

        return rows;
    }, [sortedSummaryData, expandedTenants, monthlyDataMap]);

    const getSortIcon = (key) => {
        if (sortConfig.key !== key) return null; // 👈 hide icon

        if (sortConfig.direction === 'asc') {
            return (
                <FontAwesomeIcon
                    icon={faSortUp}
                    style={{ fontSize: '0.6em', marginLeft: 4 }}
                />
            );
        }

        if (sortConfig.direction === 'desc') {
            return (
                <FontAwesomeIcon
                    icon={faSortDown}
                    style={{ fontSize: '0.6em', marginLeft: 4 }}
                />
            );
        }

        return null;
    };

    const filteredTenants = tenants.filter((tenant) => {
        if (!searchTenant.trim()) return true;

        const search = searchTenant.trim().toLowerCase();

        const name = (tenant.tenant_store_name || "").toLowerCase();
        const code = (tenant.tenant_code || "").toLowerCase(); // or tenant.tenant_code / tenant_code

        return name.includes(search) || code.includes(search);
    });

    const fetchMonthlyData = async (tenantId) => {
        if (monthlyDataMap[tenantId]) return; // already loaded

        setMonthlyLoading(prev => ({ ...prev, [tenantId]: true }));

        try {
            const payload = {
                concessionaire_id,
                tenant_id: tenantId,
                start_date: getFirstDayOfMonth(startMonth),
                end_date: getLastDayOfMonth(endMonth),
                property_name: property_id
                    ? properties.find(p => p._id === property_id)?.property_name
                    : ''
            };

            const res = await axios.post(
                `${config.hostname}/reports/getmonthlysalestrendreport/tenant`,
                payload,
                configheader
            );

            setMonthlyDataMap(prev => ({
                ...prev,
                [tenantId]: res.data.monthly_sales || []
            }));
        } catch (err) {
            toast.error('Failed to load monthly data');
        } finally {
            setMonthlyLoading(prev => ({ ...prev, [tenantId]: false }));
        }
    };

    const toggleExpandTenant = async (tenantId) => {
        setExpandedTenants(prev => ({
            ...prev,
            [tenantId]: !prev[tenantId]
        }));

        // load monthly data on first expand
        if (!expandedTenants[tenantId]) {
            await fetchMonthlyData(tenantId);
        }
    };

    const generateReport = async (e) => {
        e.preventDefault();

        // Validation for start date and end date
        if (endMonth < startMonth) {
            setValidationMessage("End month cannot be less than start month");
            return;
        } else {
            setValidationMessage("");
        }

        setExpandedTenants({});
        setMonthlyDataMap({});
        setMonthlyLoading({});

        const category_name = category_id !== '' ? categories.find(category => category._id === category_id).category_name : '';
        const property_name = property_id !== '' ? properties.find(property => property._id === property_id).property_name : '';
        const subcategory_name = subcategory_id !== '' ? subcategories.find(subcategory => subcategory._id === subcategory_id).subcategory_name : '';
        const tenant_name = tenant_id !== '' ? tenants.find(tenant => tenant._id === tenant_id).tenant_store_name : '';

        const data = {
            concessionaire_id,
            property_access: propertyAccessNames,
            start_date: getFirstDayOfMonth(startMonth),
            end_date: getLastDayOfMonth(endMonth),
            group_name,
            category_name,
            property_name,
            subcategory_name,
            tenant_id: selectedTenants,
            tenant_name,
        };

        setLoading(true)
        axios
            .post(`${config.hostname}/reports/getmonthlysalestrendreport/summary`, data, configheader)
            .then((response) => {
                setReportData(Array.isArray(response.data.tenants) ? response.data.tenants : []);
                setLoading(false)
                insertToLog(" generated Invoicewise report")
                console.log(response.data);
            })
            .catch((error) => {
                toast.error('Error');
                setLoading(false)
                console.log(error);
            });
    };

    const insertToLog = (task) => {
        const data = {
            created_by: login_id,
            concessionaire_id: concessionaire_id,
            module: "Reports",
            task: login_name + task
        }
        axios
            .post(`${config.hostname}/log`, data, configheader)
            .then(() => {
                console.log("inserted to log table")
            })
            .catch((error) => {
                toast.error('Error')
                console.log(error);

            });
    }


    const handleStartMonthChange = (e) => {
        setStartMonth(e.target.value);
        setReportData([]);
        setExpandedTenants({});
        setMonthlyDataMap({});
        setCurrentPage(0);
    };

    const handleEndMonthChange = (e) => {
        setEndMonth(e.target.value);
        setReportData([]);
        setExpandedTenants({});
        setMonthlyDataMap({});
        setCurrentPage(0);
    };

    const handleGroupChange = (e) => {
        setGroupName(e.target.value);
        setTenantId('');
        setReportData([]);
        setCurrentPage(0);
        setSelectedTenants([]);
    };

    const handlePropertyChange = (e) => {
        setPropertyId(e.target.value);
        setTenantId('');
        setReportData([]);
        setCurrentPage(0);
        setSelectedTenants([]);
    };

    const handleCategoryChange = (e) => {
        setCategoryId(e.target.value);
        setSubcategoryId('')
        setTenantId('');
        setReportData([]);
        setCurrentPage(0);
        setSelectedTenants([]);
    };

    const handleSubCategoryChange = (e) => {
        setSubcategoryId(e.target.value);
        setTenantId('')
        setReportData([]);
        setCurrentPage(0);
        setSelectedTenants([]);
    };

    // const handleTenantChange = (e) => {
    //     setTenantId(e.target.value);
    //     setReportData([]);
    //     setCurrentPage(0);
    // };


    const handleTenantChange = (e) => {
        const { value, checked } = e.target;

        setSelectedTenants((prev) => {
            if (checked) {
                // Add if not already there
                if (prev.includes(value)) return prev;
                return [...prev, value];
            } else {
                // Remove if unchecked
                return prev.filter((item) => item !== value);
            }
        });

        setReportData([]);
        setCurrentPage(0);
    };


    const handlePageClick = (data) => {
        setCurrentPage(data.selected);
    };

    //const offset = currentPage * itemsPerPage;
    const pageCount = Math.ceil(flattenedRows.length / itemsPerPage);
    const currentPageRows = flattenedRows.slice(
        currentPage * itemsPerPage,
        (currentPage + 1) * itemsPerPage
    );


    const sortedReportData = React.useMemo(() => {
        let sortableData = [...ReportData];
        if (sortConfig.key !== '') {
            sortableData.sort((a, b) => {
                if (a[sortConfig.key] < b[sortConfig.key]) {
                    return sortConfig.direction === 'asc' ? -1 : 1;
                }
                if (a[sortConfig.key] > b[sortConfig.key]) {
                    return sortConfig.direction === 'asc' ? 1 : -1;
                }
                return 0;
            });
        }
        return sortableData;
    }, [ReportData, sortConfig]);

    const currentPageData = sortedReportData.slice(currentPage * itemsPerPage, (currentPage + 1) * itemsPerPage);

    const handleExport = async (format, mode) => {
        if (!ReportData.length) return;

        // 🔹 EXPORT CURRENT VIEW
        if (mode === 'visible') {
            if (format === 'excel') {
                exportToExcel();
            } else {
                exportToPDF();
            }
            insertToLog(`exported Monthly Sales Trend Report (${mode})`);
            return;
        }

        try {
            setLoading(true);

            const payload = {
                concessionaire_id,
                start_date: getFirstDayOfMonth(startMonth),
                end_date: getLastDayOfMonth(endMonth),
                property_access: propertyAccessNames,
                property_name: property_id
                    ? properties.find(p => p._id === property_id)?.property_name
                    : '',
                category_name: category_id
                    ? categories.find(c => c._id === category_id)?.category_name
                    : '',
                subcategory_name: subcategory_id
                    ? subcategories.find(s => s._id === subcategory_id)?.subcategory_name
                    : '',
                group_name,
                tenant_id: selectedTenants,
                export_type: 'expanded'
            };

            const res = await axios.post(
                `${config.hostname}/reports/getmonthlysalestrendreport/export`,
                payload,
                configheader
            );

            if (format === 'excel') {
                exportExpandedExcel(res.data.rows);
            } else {
                exportExpandedPDF(res.data.rows);
            }

            insertToLog(`exported Monthly Sales Trend Report (${mode})`);
        } catch (err) {
            toast.error('Failed to export expanded report');
        } finally {
            setLoading(false);
            setExportMenuOpen(false);
        }
    };


    const buildExportMetadata = () => {
        const meta = [];

        if (startMonth === endMonth) {
            meta.push(['Month', formatMonthKey(startMonth)]);
        } else {
            meta.push(['From Month', formatMonthKey(startMonth)]);
            meta.push(['To Month', formatMonthKey(endMonth)]);
        }

        meta.push([
            'Property',
            property_id
                ? properties.find(p => p._id === property_id)?.property_name
                : 'All'
        ]);

        meta.push([
            'Category',
            category_id
                ? categories.find(c => c._id === category_id)?.category_name
                : 'All'
        ]);

        meta.push([
            'Subcategory',
            subcategory_id
                ? subcategories.find(s => s._id === subcategory_id)?.subcategory_name
                : 'All'
        ]);

        meta.push(['Group', group_name || 'All']);
        meta.push(['Exported By', login_name]);
        meta.push(['Exported On', new Date().toLocaleString()]);

        return meta;
    };

    const buildExportRows = () => {
        const rows = [];
        const includeMonth = Object.values(expandedTenants).some(Boolean);

        currentPageData.forEach(row => {
            // SUMMARY ROW
            const summaryRow = {
                Tenant: row.tenant_name,
                Tcode: row.tenant_code,
                Location: row.property_name,
                Category: row.category_name
            };

            // Month only if expanded exists
            if (includeMonth) {
                summaryRow.Month = '-';
            }

            Object.assign(summaryRow, {
                Gross: formatNumber(row.gross_sales),
                Tax: formatNumber(row.tax),
                Net: formatNumber(row.net_sales),
                Txn: formatNumber(row.txn / 0),
                ATV: formatNumber(row.atv),
                'MoM %': formatNumber(row.growth_mom),
                'YoY %': formatNumber(row.growth_yoy)
            });

            rows.push(summaryRow);

            // MONTHLY ROWS
            if (expandedTenants[row.tenant_id]) {
                (monthlyDataMap[row.tenant_id] || []).forEach(m => {
                    const monthlyRow = {
                        Tenant: '',
                        Tcode: '',
                        Location: '',
                        Category: '',
                        Month: formatMonthKey(m.month_key), // ✅ after Category
                        Gross: m.gross_sales,
                        Tax: m.tax,
                        Net: m.net_sales,
                        Txn: m.txn,
                        ATV: m.atv,
                        'MoM %': m.growth_mom,
                        'YoY %': m.growth_yoy
                    };

                    rows.push(monthlyRow);
                });
            }
        });

        return rows;
    };

    const exportToExcel = () => {
        const rows = buildExportRows();
        if (!rows.length) return;

        const worksheet = XLSX.utils.aoa_to_sheet([]);

        // Title
        XLSX.utils.sheet_add_aoa(
            worksheet,
            [['Monthly Sales Trend Report']],
            { origin: 'A1' }
        );

        // Metadata
        const metadata = buildExportMetadata();
        XLSX.utils.sheet_add_aoa(worksheet, metadata, { origin: 'A3' });

        // Table start row
        const tableStartRow = metadata.length + 5;

        const headers = Object.keys(rows[0]);
        XLSX.utils.sheet_add_aoa(
            worksheet,
            [headers],
            { origin: `A${tableStartRow}` }
        );

        const body = rows.map(r => headers.map(h => r[h] ?? ''));
        XLSX.utils.sheet_add_aoa(
            worksheet,
            body,
            { origin: `A${tableStartRow + 1}` }
        );

        worksheet['!cols'] = headers.map(() => ({ wch: 18 }));

        const workbook = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(workbook, worksheet, 'Monthly Sales Trend');

        XLSX.writeFile(workbook, 'MonthlySalesTrendReport.xlsx');
    };


    const exportToPDF = () => {
        const rows = buildExportRows();
        if (!rows.length) return;

        const doc = new jsPDF('l', 'pt', 'a4');

        doc.setFontSize(14);
        doc.text('Monthly Sales Trend Report', 40, 30);

        doc.setFontSize(9);

        // Metadata
        const metadata = buildExportMetadata();
        let y = 55;

        metadata.forEach(([label, value]) => {
            doc.text(`${label}: ${value}`, 40, y);
            y += 14;
        });

        const headers = Object.keys(rows[0]);
        const body = rows.map(r =>
            headers.map(h => {
                const v = r[h];
                if (typeof v === 'number') {
                    return v.toLocaleString(undefined, { minimumFractionDigits: 2 });
                }
                return v ?? '';
            })
        );

        doc.autoTable({
            startY: y + 10,
            head: [headers],
            body,
            styles: { fontSize: 8 },
            theme: 'grid',
            headStyles: { fillColor: [40, 40, 40], textColor: 255 }
        });

        doc.save('MonthlySalesTrendReport.pdf');
    };

    const exportExpandedExcel = (rows) => {
        if (!rows?.length) return;

        const worksheet = XLSX.utils.aoa_to_sheet([]);

        // Title
        XLSX.utils.sheet_add_aoa(
            worksheet,
            [['Monthly Sales Trend Report (Full Details)']],
            { origin: 'A1' }
        );

        // Metadata
        const metadata = buildExportMetadata();
        XLSX.utils.sheet_add_aoa(worksheet, metadata, { origin: 'A3' });

        const tableStartRow = metadata.length + 5;

        const headers = [
            'Tenant',
            'Tcode',
            'Location',
            'Category',
            'Month',
            'Gross',
            'Tax',
            'Net',
            'Txn',
            'ATV',
            'MoM %',
            'YoY %'
        ];

        XLSX.utils.sheet_add_aoa(
            worksheet,
            [headers],
            { origin: `A${tableStartRow}` }
        );

        const body = rows.map(r => [
            r.row_type === 'summary' ? r.tenant_name : '',
            r.row_type === 'summary' ? r.tenant_code : '',
            r.row_type === 'summary' ? r.property_name : '',
            r.row_type === 'summary' ? r.category_name : '',
            r.row_type === 'monthly' ? formatMonthKey(r.month_key) : '',
            r.gross_sales ?? '',
            r.tax ?? '',
            r.net_sales ?? '',
            r.txn ?? '',
            r.atv ?? '',
            r.growth_mom ?? '',
            r.growth_yoy ?? ''
        ]);

        XLSX.utils.sheet_add_aoa(
            worksheet,
            body,
            { origin: `A${tableStartRow + 1}` }
        );

        worksheet['!cols'] = headers.map(() => ({ wch: 18 }));

        const workbook = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(workbook, worksheet, 'Monthly Sales Trend');

        XLSX.writeFile(workbook, 'MonthlySalesTrendReport_Full.xlsx');
    };

    const exportExpandedPDF = (rows) => {
        if (!rows?.length) return;

        const doc = new jsPDF('l', 'pt', 'a4');

        doc.setFontSize(14);
        doc.text('Monthly Sales Trend Report (Full Details)', 40, 30);

        doc.setFontSize(9);

        const metadata = buildExportMetadata();
        let y = 55;

        metadata.forEach(([label, value]) => {
            doc.text(`${label}: ${value}`, 40, y);
            y += 14;
        });

        const headers = [
            'Tenant',
            'Tcode',
            'Location',
            'Category',
            'Month',
            'Gross',
            'Tax',
            'Net',
            'Txn',
            'ATV',
            'MoM %',
            'YoY %'
        ];

        const body = rows.map(r => [
            r.row_type === 'summary' ? r.tenant_name : '',
            r.row_type === 'summary' ? r.tenant_code : '',
            r.row_type === 'summary' ? r.property_name : '',
            r.row_type === 'summary' ? r.category_name : '',
            r.row_type === 'monthly' ? formatMonthKey(r.month_key) : '',
            formatNumber(r.gross_sales),
            formatNumber(r.tax),
            formatNumber(r.net_sales),
            r.txn ?? '',
            formatNumber(r.atv),
            r.growth_mom != null ? `${r.growth_mom.toFixed(2)}%` : '',
            r.growth_yoy != null ? `${r.growth_yoy.toFixed(2)}%` : ''
        ]);

        doc.autoTable({
            startY: y + 10,
            head: [headers],
            body,
            styles: { fontSize: 8 },
            theme: 'grid',
            headStyles: { fillColor: [40, 40, 40], textColor: 255 }
        });

        doc.save('MonthlySalesTrendReport_Full.pdf');
    };

    const formatNumber = (v) => typeof v === 'number' ? v.toLocaleString(undefined, { minimumFractionDigits: 2 }) : '';

    const reset = () => {
        const defaultMonth = getYesterdayMonth();
        setStartMonth(defaultMonth);
        setEndMonth(defaultMonth);
        setPropertyId('');
        setCategoryId('');
        setSubcategoryId('');
        setGroupName('');
        setTenantId('');
        setSelectedTenants([]);
        setSearchTenant('');
        setDropdownOpen(false);
        setReportData([])
        setValidationMessage('');
        setExpandedTenants({});
        setMonthlyDataMap({});
        setMonthlyLoading({});
    }

    return (
        <Fragment>
            <Form className='theme-form' onSubmit={generateReport}>
                <Card>
                    <CardBody>
                        <Row>
                            <Col>
                                <FormGroup className="mb-3">
                                    <Label htmlFor="startmonth">Start Month</Label>
                                    <input className="form-control"
                                        id="startmonth" type="month" name="startmonth" value={startMonth}
                                        max={currentMonth} onChange={handleStartMonthChange} required />
                                </FormGroup>
                            </Col>
                            <Col>
                                <FormGroup className="mb-3">
                                    <Label htmlFor="endmonth">End Month</Label>
                                    <input className="form-control digits"
                                        id="endmonth" type="month" name="endmonth" value={endMonth}
                                        max={currentMonth} onChange={handleEndMonthChange} required />
                                </FormGroup>
                                {validationMessage && (
                                    <span className="text-danger">{validationMessage}</span>
                                )}
                            </Col>
                            <Col>
                                <FormGroup className="mb-3">
                                    <Label htmlFor="property_id">Property</Label>
                                    <select name="property_id" id="property_id" className="form-control"
                                        value={property_id} onChange={handlePropertyChange}>
                                        <option value="">All</option>
                                        {properties.map(property => (
                                            <option key={property._id} value={property._id}>{property.property_name}</option>
                                        ))}
                                    </select>
                                </FormGroup>
                            </Col>
                        </Row>
                        <Row>
                            <Col>
                                <FormGroup className="mb-3">
                                    <Label htmlFor="category_id">Category</Label>
                                    <select name="category_id" id="category_id" className="form-control"
                                        value={category_id} onChange={handleCategoryChange}>
                                        <option value="">All</option>
                                        {categories.map(category => (
                                            <option key={category._id} value={category._id}>{category.category_name}</option>
                                        ))}
                                    </select>
                                </FormGroup>
                            </Col>
                            <Col>
                                <FormGroup className="mb-3">
                                    <Label htmlFor="subcategory_id">Sub Category</Label>
                                    <select name="subcategory_id" id="subcategory_id" className="form-control"
                                        value={subcategory_id} onChange={handleSubCategoryChange}>
                                        <option value="">All</option>
                                        {subcategories.map(subcategory => (
                                            <option key={subcategory._id} value={subcategory._id}>{subcategory.subcategory_name}</option>
                                        ))}
                                    </select>
                                </FormGroup>
                            </Col>
                            <Col>
                                <FormGroup className="mb-3">
                                    <Label htmlFor="subcategory_id">Group</Label>
                                    <select name="subcategory_id" id="subcategory_id" className="form-control"
                                        value={group_name} onChange={handleGroupChange}>
                                        <option value="">All</option>
                                        {groups.map((group, index) => (
                                            <option key={index} value={group}>{group}</option>
                                        ))}
                                    </select>
                                </FormGroup>
                            </Col>

                            <Col>
                                <div style={{ position: 'relative', width: '100%' }} ref={dropdownRef}>
                                    <label>Tenants</label>
                                    <div
                                        onClick={toggleDropdown}
                                        style={{
                                            border: '1px solid #ccc',
                                            padding: '8px',
                                            borderRadius: '4px',
                                            cursor: 'pointer',
                                            display: 'flex',
                                            justifyContent: 'space-between',
                                            alignItems: 'center',
                                        }}
                                    >
                                        <div>Select Tenants</div>
                                        <span style={{ marginLeft: 'auto' }}>&#9662;</span>
                                    </div>
                                    {dropdownOpen && (
                                        <div
                                            onClick={(e) => e.stopPropagation()}
                                            style={{
                                                position: 'absolute',
                                                top: '100%',
                                                left: 0,
                                                width: '100%',
                                                backgroundColor: '#fff',
                                                border: '1px solid #ccc',
                                                borderRadius: '4px',
                                                marginTop: '4px',
                                                zIndex: 1,
                                                boxShadow: '0px 4px 8px rgba(0, 0, 0, 0.1)',
                                                maxHeight: '250px', // Set the maximum height for the dropdown
                                                overflowY: 'auto' // Scrollable content
                                            }}
                                        >
                                            {/* Search Bar */}
                                            <div style={{ padding: '8px', borderBottom: '1px solid #ccc' }}>
                                                <input
                                                    type="text"
                                                    placeholder="Search tenants..."
                                                    value={searchTenant}
                                                    onChange={(e) => setSearchTenant(e.target.value)}
                                                    style={{
                                                        width: '100%',
                                                        padding: '6px',
                                                        border: '1px solid #ccc',
                                                        borderRadius: '4px'
                                                    }}
                                                />
                                            </div>

                                            {/* Filtered Tenants List */}
                                            {filteredTenants.length > 0 ? (
                                                filteredTenants.map(tenant => (
                                                    <label
                                                        key={tenant._id}
                                                        style={{ display: 'block', padding: '8px', cursor: 'pointer' }}
                                                    >
                                                        <input
                                                            type="checkbox"
                                                            value={tenant._id}
                                                            checked={selectedTenants.includes(tenant._id)}
                                                            onChange={handleTenantChange}
                                                            style={{ marginRight: '8px' }}
                                                        />

                                                        {/* 👇 Display code + name */}
                                                        <span style={{ fontWeight: 500 }}>
                                                            {tenant.tenant_store_name}
                                                            {tenant.tenant_code ? ` - ${tenant.tenant_code}` : ""}
                                                        </span>
                                                    </label>
                                                ))
                                            ) : (
                                                <div style={{ padding: '8px', color: 'gray', textAlign: 'center' }}>
                                                    No results found
                                                </div>
                                            )}

                                        </div>
                                    )}
                                </div>
                            </Col>

                        </Row>
                        <Row>
                            <Col >
                                <Btn attrBtn={{ color: 'primary', className: 'me-3', type: "submit" }} >Generate Report</Btn>
                                <Btn attrBtn={{ color: 'primary', className: 'me-3', onClick: reset }} >Reset</Btn>
                            </Col>

                        </Row>


                    </CardBody>
                </Card>
            </Form>
            {loading === true ? (
                <div className="loader-box">
                    <Spinner attrSpinner={{ className: 'loader-3' }} />
                </div>

            ) : (
                <Card>
                    <CardHeader>
                        <Row className="justify-content-end">
                            <Col xs="auto" style={{ position: 'relative' }}>
                                <Btn
                                    attrBtn={{
                                        color: 'primary',
                                        type: 'button',
                                        onClick: () => setExportMenuOpen(prev => !prev),
                                        onMouseEnter: () => handleMouseEnter('Export to Excel'),
                                        onMouseLeave: handleMouseLeave
                                    }}
                                >
                                    <FontAwesomeIcon icon={faFileExcel} size="lg" />
                                </Btn>

                                {tooltip === 'Export to Excel' && (
                                    <div style={{
                                        position: 'absolute',
                                        top: '-30px',
                                        left: '50%',
                                        transform: 'translateX(-50%)',
                                        backgroundColor: 'black',
                                        color: 'white',
                                        padding: '5px 10px',
                                        borderRadius: '3px',
                                        whiteSpace: 'nowrap',
                                        fontSize: '12px',
                                        zIndex: 20,
                                    }}>
                                        {tooltip}
                                    </div>
                                )}

                                {exportMenuOpen && (
                                    <div
                                        ref={exportRef}
                                        onClick={(e) => e.stopPropagation()}
                                        style={{
                                            position: 'absolute',
                                            right: 0,
                                            top: '110%',
                                            backgroundColor: '#fff',
                                            border: '1px solid #ddd',
                                            borderRadius: '6px',
                                            boxShadow: '0 4px 10px rgba(62, 31, 31, 0.15)',
                                            zIndex: 50,
                                            minWidth: '220px',
                                            overflow: 'hidden'
                                        }}
                                    >
                                        <div
                                            style={dropdownItemStyle}
                                            onMouseEnter={handleExportHoverIn}
                                            onMouseLeave={handleExportHoverOut}
                                            onClick={() => {
                                                handleExport('excel', 'visible');
                                                setExportMenuOpen(false);
                                            }}
                                        >
                                            📄 Export Current View
                                        </div>

                                        <div
                                            style={dropdownItemStyle}
                                            onMouseEnter={handleExportHoverIn}
                                            onMouseLeave={handleExportHoverOut}
                                            onClick={() => {
                                                handleExport('excel', 'expanded');
                                                setExportMenuOpen(false);
                                            }}
                                        >
                                            📊 Export Full Details
                                        </div>

                                    </div>
                                )}
                            </Col>

                            <Col xs="auto" style={{ position: 'relative' }}>
                                <Btn
                                    attrBtn={{
                                        color: 'primary',
                                        type: 'button',
                                        onClick: () => setPdfMenuOpen(prev => !prev),
                                        onMouseEnter: () => handleMouseEnter('Export to PDF'),
                                        onMouseLeave: handleMouseLeave
                                    }}
                                >
                                    <FontAwesomeIcon icon={faFilePdf} size="lg" />
                                </Btn>

                                {tooltip === 'Export to PDF' && (
                                    <div style={{
                                        position: 'absolute',
                                        top: '-30px',
                                        left: '50%',
                                        transform: 'translateX(-50%)',
                                        backgroundColor: 'black',
                                        color: 'white',
                                        padding: '5px 10px',
                                        borderRadius: '3px',
                                        whiteSpace: 'nowrap',
                                        fontSize: '12px',
                                        zIndex: 20,
                                    }}>
                                        {tooltip}
                                    </div>
                                )}

                                {pdfMenuOpen && (
                                    <div
                                        ref={pdfRef}
                                        onClick={(e) => e.stopPropagation()}
                                        style={{
                                            position: 'absolute',
                                            right: 0,
                                            top: '110%',
                                            backgroundColor: '#fff',
                                            border: '1px solid #ddd',
                                            borderRadius: '6px',
                                            boxShadow: '0 4px 10px rgba(62, 31, 31, 0.15)',
                                            zIndex: 50,
                                            minWidth: '220px',
                                            overflow: 'hidden'
                                        }}
                                    >
                                        <div
                                            style={dropdownItemStyle}
                                            onMouseEnter={handleExportHoverIn}
                                            onMouseLeave={handleExportHoverOut}
                                            onClick={() => {
                                                handleExport('pdf', 'visible');
                                                setPdfMenuOpen(false);
                                            }}
                                        >
                                            📄 Export Current View
                                        </div>

                                        <div
                                            style={dropdownItemStyle}
                                            onMouseEnter={handleExportHoverIn}
                                            onMouseLeave={handleExportHoverOut}
                                            onClick={() => {
                                                handleExport('pdf', 'expanded');
                                                setPdfMenuOpen(false);
                                            }}
                                        >
                                            📊 Export Full Details
                                        </div>
                                    </div>
                                )}
                            </Col>

                        </Row>
                    </CardHeader>
                    <CardBody>
                        <Col sm="12" lg="12" xl="12">
                            <div className="table-responsive" >
                                <Table style={{ tableLayout: 'auto', whiteSpace: 'nowrap' }}>
                                    <thead>
                                        <tr>
                                            <th></th>

                                            {SUMMARY_COLUMNS.map((col, idx) => (
                                                <React.Fragment key={col.key}>
                                                    <th
                                                        onClick={() =>
                                                            setSortConfig(prev => ({
                                                                key: col.key,
                                                                direction:
                                                                    prev.key === col.key && prev.direction === 'asc'
                                                                        ? 'desc'
                                                                        : 'asc'
                                                            }))
                                                        }
                                                        style={{ cursor: 'pointer', whiteSpace: 'nowrap' }}
                                                    >
                                                        {col.label}
                                                        {getSortIcon(col.key)}
                                                    </th>

                                                    {/* INSERT MONTH AFTER CATEGORY */}
                                                    {isAnyExpanded && idx === CATEGORY_INDEX && <th>Month</th>}
                                                </React.Fragment>
                                            ))}
                                        </tr>
                                    </thead>

                                    <tbody>
                                        {currentPageRows.map((row, idx) => {
                                            if (row.type === 'summary') {
                                                const r = row.data;

                                                return (
                                                    <tr key={`s-${idx}`} style={{ background: '#f8f9fa' }}>
                                                        <td>
                                                            <Btn
                                                                attrBtn={{
                                                                    size: 'sm',
                                                                    color: 'primary',
                                                                    onClick: () => toggleExpandTenant(r.tenant_id)
                                                                }}
                                                            >
                                                                {expandedTenants[r.tenant_id] ? '−' : '+'}
                                                            </Btn>
                                                        </td>

                                                        {SUMMARY_COLUMNS.map((col, idx) => (
                                                            <React.Fragment key={col.key}>
                                                                <td>
                                                                    {col.format === 'number'
                                                                        ? (r[col.key] ?? 0).toLocaleString(undefined, {
                                                                            minimumFractionDigits: 2,
                                                                            maximumFractionDigits: 2
                                                                        })
                                                                        : col.format === 'percent'
                                                                            ? r[col.key] != null ? `${r[col.key].toFixed(2)}%` : '-'
                                                                            : r[col.key] || ''}
                                                                </td>

                                                                {/* Month placeholder */}
                                                                {isAnyExpanded && idx === CATEGORY_INDEX && <td>-</td>}
                                                            </React.Fragment>
                                                        ))}
                                                    </tr>
                                                );
                                            }

                                            // MONTHLY ROW
                                            const m = row.data;

                                            return (
                                                <tr key={`m-${idx}`}>
                                                    <td></td>

                                                    {SUMMARY_COLUMNS.map((col, idx) => (
                                                        <React.Fragment key={col.key}>
                                                            <td>
                                                                {col.key === 'gross_sales' ? m.gross_sales?.toLocaleString(undefined, { minimumFractionDigits: 2 })
                                                                    : col.key === 'tax' ? m.tax?.toLocaleString(undefined, { minimumFractionDigits: 2 })
                                                                        : col.key === 'net_sales' ? m.net_sales?.toLocaleString(undefined, { minimumFractionDigits: 2 })
                                                                            : col.key === 'txn' ? m.txn
                                                                                : col.key === 'atv' ? m.atv?.toLocaleString(undefined, { minimumFractionDigits: 2 })
                                                                                    : col.key === 'growth_mom' ? m.growth_mom != null ? `${m.growth_mom.toFixed(2)}%` : '-'
                                                                                        : col.key === 'growth_yoy' ? m.growth_yoy != null ? `${m.growth_yoy.toFixed(2)}%` : '-'
                                                                                            : ''}
                                                            </td>

                                                            {/* Month value */}
                                                            {isAnyExpanded && idx === CATEGORY_INDEX && (
                                                                <td><strong>{formatMonthKey(m.month_key)}</strong></td>
                                                            )}
                                                        </React.Fragment>
                                                    ))}                                                    
                                                </tr>
                                            );
                                        })}
                                    </tbody>
                                </Table>
                            </div>
                            {ReportData.length > 50 && (
                                <ReactPaginate
                                    previousLabel={'<<'}
                                    nextLabel={'>>'}
                                    breakLabel={'...'}
                                    breakClassName={'break-me'}
                                    pageCount={pageCount}
                                    marginPagesDisplayed={2}
                                    pageRangeDisplayed={5}
                                    onPageChange={handlePageClick}
                                    containerClassName={'pagination'}
                                    subContainerClassName={'pages pagination'}
                                    activeClassName={'active'}
                                    pageClassName={'page-item'}
                                    pageLinkClassName={'page-link'}
                                />
                            )}
                        </Col>
                    </CardBody>
                </Card>
            )}
        </Fragment>
    );
};
export default MonthlySalesTrendReportView;